<template>
    <div class="actions-page" v-if="currentCity.length && pageSetup != null">
        <div class="container">
            <div class="section-title">
                <h1>{{pageSetup.page_title}}</h1>
            </div>
            <actionsFilter></actionsFilter>
            <actionsItems></actionsItems>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import actionsItems from '@/components/actions/action-item.vue'
    import actionsFilter from '@/components/actions/actions-filter.vue'
    export default {
        name: 'actions--page',
        components: {
            actionsItems,
            actionsFilter
        },
        data () {
            return {
                title: 'Акции',
            }
        },
        computed: mapGetters({
            currentCity: 'loadCurrentCity',
            pageSetup: 'loadActionPage',
        }),
        methods: {
        },
        beforeCreate() {
            this.$store.dispatch('getActionPageData');
            this.$store.dispatch('getActionsItems');
            document.body.dataset.page = 'actions';
        },
        created () {
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>